import { create, all } from 'mathjs';

export const mathConfig = {
  precision: 14,
};
export const mathJS = create(all, mathConfig);
